<script>
    import Footer from '../landing_page/footer.svelte';
    import FaqSection from './faq_section.svelte';
    import HeaderProgramSection from './header_program_section.svelte';
    import SpeakerSlider from './mobile_reuse-section/speaker_slider.svelte';
    import {
        heroTraining,
        sliderHeroTraining,
        sliderFromLeft,
        FaqHeroTraining,
    } from './program_data.js';
    import {
        speakerSection,
        sliderRightMbl,
        sliderLeftMbl,
        heroCurriculumMbl,
    } from './mobile_reuse-section/mobile_reuse_section_data.js';
    import SliderFromLeft from './slider_from_left.svelte';
    import SliderFromRight from './slider_from_right.svelte';
    import SliderRightMbl from './mobile_reuse-section/slider_right_mbl.svelte';
    import SliderLeftMbl from './mobile_reuse-section/slider_left_mbl.svelte';
    import CurriculumMbl from './mobile_reuse-section/curriculum_mbl_hero.svelte';
    import FaqMbl from './mobile_reuse-section/faq_mbl.svelte';
    const {title} = rpcjs.props;
    title.set('Hero | Program');
    const Curriculum = [
        {
            img: '/images/Hero_section/Hero_Training_icons/Vision_and_Future.svg',
            title: 'Vision and Future',
            width: '6.440vw',
            left: '4.696vw',
            leftdescription: '7.184vw',
            description:
                'Develop a clear vision for your business venture via ' +
                'processes such as futurology, predictive analysis and idea generation.',
            bullet1: [
                {
                    bulltes: 'Futurology',
                },
                {
                    bulltes: 'Idea Generation',
                },
                {
                    bulltes: 'Predictive Analysis',
                },
                {
                    bulltes: 'Young Founder Series',
                },
            ],
        },
        {
            img: '/images/Hero_section/Hero_Training_icons/Money_and_Resources.svg',
            title: 'Money and Resources',
            width: '6vw',
            left: '3.792vw',
            leftdescription: '7.937vw',
            description:
                'Discover how to access and leverage a variety of financial resources to launch' +
                'and sustain your business concept. Examples include venture capital, fundraising strategies and crypto.',
            bullet1: [
                {
                    bulltes: 'Everything Crypto',
                },
                {
                    bulltes: 'Venture Capital',
                },
                {
                    bulltes: 'Banking & Finance',
                },
                {
                    bulltes: 'Fundraising Strategies',
                },
            ],
        },
        {
            img: '/images/Hero_section/Hero_Training_icons/Strenght_and_Speed.svg',
            title: 'Strenght and Speed',
            width: '4.919vw',
            left: '5.068vw',
            leftdescription: '6.5vw',
            description:
                'Learn how to use prototyping to develop your business idea, ' +
                'run a lean operation and scale your enterprise when the time comes.',
            bullet1: [
                {
                    bulltes: 'Prototyping',
                },
                {
                    bulltes: 'Founders vs CEOs',
                },
                {
                    bulltes: 'Scaling Your Business',
                },
                {
                    bulltes: 'Learn Startup Methadology',
                },
            ],
        },
        {
            img: '/images/Hero_section/Hero_Training_icons/Legal_and_Justice.svg',
            title: 'Legal and Justice',
            width: '4.791vw',
            left: '5.622vw',
            leftdescription: '6.2vw',
            description:
                'Determine the best company structure for your organization from a legal' +
                'perspective (corporation, LLC, etc.) and receive a law primer geared towards startup ventures.',
            bullet1: [
                {
                    bulltes: 'Term Sheets',
                },
                {
                    bulltes: 'Incorporation',
                },
                {
                    bulltes: 'Company Structure',
                },
                {
                    bulltes: 'Law Primer for Startups',
                },
            ],
        },
        {
            img: '/images/Hero_section/Hero_Training_icons/Creativity.svg',
            title: 'Creativity',
            width: '2.726vw',
            left: '6.680vw',
            leftdescription: '5.3vw',
            description:
                'Learn how to become a zealous advocate for your startup and promote your business effectively ' +
                ' through media training, branding and storytelling, sales and digital marketing and networking.',
            bullet1: [
                {
                    bulltes: 'Pretotypin',
                },
                {
                    bulltes: 'Design Thinkin',
                },
                {
                    bulltes: 'Disruptive Innovatio',
                },
                {
                    bulltes: 'Designing Products and Team',
                },
            ],
        },
        {
            img: '/images/Hero_section/Hero_Training_icons/Special_Power.svg',
            title: 'Special Power',
            width: '2.249vw',
            left: '6.151vw',
            leftdescription: '5.8vw',
            description:
                'Unleash your creativity and validate your product ideas with tools and techniques like prototyping,' +
                ' disruptive innovation and design thinking.',
            bullet1: [
                {
                    bulltes: 'Coding',
                },
                {
                    bulltes: 'Negotiations',
                },
                {
                    bulltes: 'Lie Detection',
                },
                {
                    bulltes: 'Perfecting Your Pitching',
                },
            ],
        },
        {
            img: '/images/Hero_section/Hero_Training_icons/Evangelism.svg',
            title: 'Evangelism',
            width: '3.770vw',
            left: '5.886vw',
            leftdescription: '6vw',
            description:
                'Numerous obstacles and a few potholes line the road to success. Develop the warrior' +
                ' mindset you need to keep going when things get tough. You`ll also learn how to ' +
                ' take lessons from failure and use them to your advantage.',
            bullet1: [
                {
                    bulltes: 'Media Training',
                },
                {
                    bulltes: 'Branding and Storytelling',
                },
                {
                    bulltes: 'Power Up your Network',
                },
                {
                    bulltes: 'Sales and Digital Marketing',
                },
            ],
        },
        {
            img: '/images/Hero_section/Hero_Training_icons/Survival.svg',
            title: 'Survival',
            width: '4.696vw',
            left: '5.754vw',
            leftdescription: '6.3vw',
            description:
                'You`ll need a few special powers to achieve your entrepreneurial goals. Learn to' +
                ' master the fine arts of negotiating, idea pitching and lie detection to give you a competitive edge.',
            bullet1: [
                {
                    bulltes: 'Warrior Mindset',
                },
                {
                    bulltes: 'Lessons in Failure',
                },
                {
                    bulltes: 'Resource Valuation',
                },
                {
                    bulltes: 'Critical Success Factor',
                },
            ],
        },
    ];
    const People = [
        {
            img: 'images/Hero_section/speakers/aaron_levie.png',
            name: 'Aaron Levie',
            about: 'Box',
        },
        {
            img: 'images/Hero_section/speakers/steve_jurvetson.png',
            name: 'Steve Jurvetson',
            about: 'Venture Capitalist',
        },
        {
            name: 'Elon Musk',
            about: 'Tesla',
            img: 'images/Hero_section/speakers/elon_musk.png',
        },
        {
            name: 'Andrew Chen',
            about: 'a16z',
            img: 'images/Hero_section/speakers/andrew_chen.png',
        },
        {
            name: 'Borja Martel',
            about: 'Lemon Cash',
            img: 'images/Hero_section/speakers/borja_martel.png',
        },
        {
            name: 'Amanda Bradford',
            about: 'The League',
            img: 'images/Hero_section/speakers/amanda_bradford.png',
        },
        {
            name: 'Michelle Phan',
            about: 'EM Cosmetics',
            img: 'images/Hero_section/speakers/michelle_phan.png',
        },
        {
            name: 'John Zimmer',
            about: 'Lyft',
            img: 'images/Hero_section/speakers/john_zimmer.png',
        },
    ];
    const Processtext = [
        {
            heading: 'Apply',
            text:
                'Our application is simple. Tell us your business idea (if you have one), ' +
                ' and why you were put on this earth. Include what makes you unique!',
        },
        {
            heading: 'Interview',
            text:
                'After receiving your application, we will schedule a 15-minute Skype ' +
                ' interview with a member of our admissions team to learn more about your background.',
        },
        {
            heading: 'Scholarship',
            text:
                'There are a limited number of scholarships available for each cohort and ' +
                ' we also offer payment installments that you can discuss with our team.',
        },
        {
            heading: 'Get Notified',
            text:
                'After the interview, you will receive an admissions decision within 3-4 weeks.' +
                ' Financial Aid is awarded on a rolling basis, so apply ASAP!',
        },
    ];
    const benefitsMbl = [
        {
            back_color: '#36A1BF',
            image: '/images/Hero_section/exploration.svg',
            heading: 'Exploration',
            paragraph:
                'Learn how to develop your business from Silicon Valley Founders and Experts',
        },
        {
            back_color: '#3C74C0',
            image: '/images/Hero_section/acceleration.svg',
            heading: 'Acceleration',
            paragraph:
                'The Program is delivered through online lectures by Silicon ' +
                ' Valley Experts and Founders, and through group live activities around challenges',
        },
        {
            back_color: '#16519A',
            image: '/images/Hero_section/networking.svg',
            heading: 'Networking',
            paragraph:
                '5 Sessions of 1-1 Mentoring with Worldwide industry experts,' +
                ' mentors and investors committed to supporting you on your entrepreneurial journey',
        },
        {
            back_color: '#15248E',
            image: '/images/Hero_section/heroism.svg',
            heading: 'Heroism ',
            paragraph:
                'Draper University has a fund dedicated to investing up ' +
                ' to $100,000 in chosen alumni companies of this program',
        },
    ];
    const user = {view_all: false};
/**
   *
   */
    function toggle() {
        user.view_all = !user.view_all;
    }
    const userMbl = {view_all_mbl: false};
/**
   *
   */
    function toggleMbl() {
        userMbl.view_all_mbl = !userMbl.view_all_mbl;
    }
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <HeaderProgramSection
        data={heroTraining}
        lineHeight="17.299vw"
        colors="white"
        headingTop="-10vw"
        headingLeft="0vw"
        TopMbl="120vw"
        lineHeightMbl="9vw"
        hrWidth="34.929vw"
        widthDescription="61.516vw"
        discTop="37vw"
    />
    <div class="desktop">
        <div
            style="display: flex;align-items:center; margin-left:5.556vw;margin-top: 11.905vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5.82vw; opacity:0.3;"
            >
                01
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);
                font-weight:500;
                font-size:2.068vw;text-transform: uppercase;"
            >
                Curriculum Highlights
            </h1>
        </div>
        <div style="position: relative; margin-top: -5.3vw;">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
        </div>
        <div class="desktop">
            <div
                style="width: 88.815vw;margin-left: 5.622vw;
            margin-top: 8.571vw;"
            >
                <div
                    style="border-radius:1.2vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);margin-top:5vw;"
                >
                    {#each Curriculum as CurriculumText}
                        <div class="content-holder">
                            <div
                                style="display: inline-flex;
                                    align-items: center;
                                    height: 13.228vw;"
                            >
                                <div
                                    class="img-wrraper-logo"
                                    style="width: 5.5vw;margin-right: {CurriculumText.leftdescription}; margin-left:{CurriculumText.left}"
                                >
                                    <img
                                        style="width:{CurriculumText.width};"
                                        src={CurriculumText.img}
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div style="display: flex;">
                                    <div
                                        style="align-items: center; margin: auto;"
                                    >
                                        <div>
                                            <h1
                                                class="section1list"
                                                style="    font-size: 1.985vw;
                                                color: rgba(0, 32, 75, 1);
                                                font-weight: 600;"
                                            >
                                                {CurriculumText.title}
                                            </h1>
                                        </div>
                                        <div
                                            style="font-size: 1.190vw; width:42.989vw; color:
                                            rgba(0, 32, 75, 1);"
                                        >
                                            <p>
                                                {CurriculumText.description}
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <ul>
                                            {#each CurriculumText.bullet1 as data}
                                                <li style="">
                                                    <p
                                                        style=" padding-left: 0.46vw;
                                                        font-size: 1.19vw;
                                                        color: rgba(0, 32, 75, 1);"
                                                    >
                                                        {data.bulltes}
                                                    </p>
                                                </li>
                                            {/each}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
        <div>
            <div
                class="speaker"
                style="margin-top: 15.013vw; margin-bottom: 14.418vw;gap: 3.638vw;"
            >
                <div
                    style="display: flex;align-items:center; margin-left: 10.78vw; margin-top: -29vw;"
                >
                    <h1
                        class="section-title"
                        style="font-weight:500;
                    color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                    >
                        Speakers
                    </h1>
                </div>
                <div
                    style="display: flex;flex-wrap: wrap;justify-content: center;width: 70vw;"
                >
                    {#each People as data}
                        <div class="speaker_box">
                            <div
                                style="overflow: hidden;
                            height: 100%;
                            border-bottom-right-radius: 0.7vw;
                            border-bottom-left-radius: 0.7vw;"
                            >
                                <div
                                    style="
                                    width: 8.532vw;
                                    height: 8.532vw;
                                    border-radius: 50%;
                                    margin: auto;
                                    padding-top: 1.5vw;
                                "
                                >
                                    <img src={data.img} alt="" width="100%" />
                                </div>
                                <div
                                    style="margin-top:3.4vw;text-align:center;padding:1vw;background-color:#f4f4f4;"
                                >
                                    <h1
                                        style="font-size:1.190vw; font-weight:600;"
                                    >
                                        {data.name}
                                    </h1>
                                    <h1 style="font-size: 0.926vw;">
                                        {data.about}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
            <div
                style="width: 88.815vw;margin: auto;
            margin-top: 10vw;"
            >
                <div style="display: flex;align-items:center">
                    <h1
                        style="color: rgb(0, 32, 75);
                        font-size: 1.191vw;
                        margin-right: 5vw;
                        opacity: 0.3;
                        margin-top: 0.6vw;"
                    >
                        02
                    </h1>
                    <h1
                        style="font-weight:500;
                    color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                    >
                        Benefits of this Program
                    </h1>
                </div>
                <div />
            </div>
            <div style="display: flex;">
                <div
                    style="width: 22.090vw; margin-top:9.061vw;margin-left:9.854vw;"
                >
                    <img
                        src="/images/Hero_section/Hero_Training_benefits.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="position: relative;">
                    <div class="inner-circle" />
                    <div class="funnel-div">
                        <div style="display: flex; justify-content: center;">
                            <div class="fund-icon">
                                <img
                                    src="/images/Hero_section/exploration.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <p
                                    class="fund-heading"
                                    style="padding: 0vw 1vw;
                                    padding-bottom: 0.8vw;
                                    margin: 0vw;"
                                >
                                    Exploration
                                </p>
                            </div>
                        </div>

                        <p
                            class="fund-text"
                            style="width: 19.381vw; margin:auto;"
                        >
                            Learn how to develop your business from Silicon
                            Valley Founders and Experts
                        </p>
                    </div>
                    <div class="expert-div">
                        <div style="display: flex; justify-content: center;">
                            <div class="fund-icon">
                                <img
                                    style="
        width: 2.910vw;
        margin-left: -1vw;
        margin-top: 0.2vw;"
                                    src="/images/Hero_section/acceleration.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <p
                                    class="fund-heading"
                                    style="padding: 0vw 1vw;
                                    margin: 0vw;
                                    padding-bottom: 1vw;
                                    line-height: 1.653vw;"
                                >
                                    Acceleration
                                </p>
                            </div>
                        </div>

                        <p
                            class="fund-text"
                            style="  width: 19.38vw; margin:auto;"
                        >
                            The Program is delivered through online lectures by
                            Silicon Valley Experts and Founders, and through
                            group live activities around challenges
                        </p>
                    </div>
                    <div class="globel-div" style="padding-top: 1.7vw;">
                        <div style="display: flex; justify-content: center;">
                            <div class="fund-icon">
                                <img
                                    src="/images/Hero_section/networking.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <p
                                    class="fund-heading"
                                    style="    padding: 0vw 1vw;
                                    margin: 0vw;
                                    padding-bottom: 1vw;"
                                >
                                    Networking
                                </p>
                            </div>
                        </div>

                        <p
                            class="fund-text"
                            style="width: 18.381vw; margin: auto;"
                        >
                            5 Sessions of 1-1 Mentoring with Worldwide industry
                            experts, mentors and investors committed to
                            supporting you on your entrepreneurial journey
                        </p>
                    </div>
                    <div class="growth-div">
                        <div style="display: flex; justify-content: center;">
                            <div class="fund-icon">
                                <img
                                    src="/images/Hero_section/heroism.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <p
                                    class="fund-heading"
                                    style="padding: 0vw 1vw;"
                                >
                                    Heroism
                                </p>
                            </div>
                        </div>

                        <p
                            class="fund-text"
                            style="width: 20.381vw; margin:auto;"
                        >
                            Draper University has a fund dedicated to investing
                            up to $100,000 in chosen alumni companies of this
                            program
                        </p>
                    </div>
                </div>
            </div>
            <div
                style="width: 88.815vw;margin: auto;
            margin-top: 10vw;padding:0 1vw;"
            >
                <div style="display: flex;align-items:center">
                    <h1
                        style="    color: rgb(0, 32, 75);
                        font-size: 1.191vw;
                        margin-right: 5vw;
                        opacity: 0.3;
                        margin-top: 0.6vw;"
                    >
                        03
                    </h1>
                    <h1
                        style="font-weight:500;
                    color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                    >
                        Alumni Success Stories
                    </h1>
                </div>
                <div />
            </div>
            <SliderFromRight data={sliderHeroTraining} />
            <SliderFromLeft data={sliderFromLeft} />
            <div
                style="display: flex;align-items:center; margin-left:5.159vw; margin-top:20vw;"
            >
                <h1
                    class="section1"
                    style="color: rgb(0, 32, 75);
                    font-size: 1.191vw;
                    margin-right: 5vw;
                    opacity: 0.3;
                    margin-top: 0.6vw;;"
                >
                    04
                </h1>
                <h1
                    class="section-title"
                    style="font-weight:500;
                color:rgba(0, 32, 75, 1);
                font-size:2.068vw;text-transform: uppercase;"
                >
                    DUV Companies
                </h1>
            </div>
            <div
                style="width: 72.718vw;
            margin-top: 4.034vw;
            margin-left: 12.963vw;"
            >
                <img
                    alt=""
                    src="/images/Hero_section/group_company.png"
                    width="100%"
                />
            </div>
            <div style="width: 88.815vw;margin:10vw auto;padding:0 1vw;">
                <div
                    style="display: flex;align-items:center;justify-content: space-between;"
                >
                    <div style="position: relative; margin-top: -16vw">
                        <div style="display:flex;align-items: center;">
                            <h1
                                style="color: rgb(0, 32, 75);
                                font-size: 1.191vw;
                                margin-right: 1vw;
                                opacity: 0.3;
                                margin-top: 2.6vw;"
                            >
                                05
                            </h1>
                            <h1
                                style="color: rgba(124, 193, 255, 0.2);font-size: 9.259vw;font-weight: bold; line-height: 12.235vw;"
                            >
                                Become a <br /> Hero
                            </h1>
                        </div>

                        <div
                            style="position:absolute;top: 12vw;left: 19.423vw;"
                        >
                            <div>
                                <h1
                                    style="font-weight:500;
                                font-size:1.985vw;
                                color: #00204B;text-transform: uppercase; "
                                >
                                    Application
                                </h1>
                                <div style="width:21.429vw; margin:2vw 0vw">
                                    <p
                                        style="font-size:1.191vw; color:rgba(0, 32, 75, 1);"
                                    >
                                        Applying for entrepreneurship training
                                        in Silicon Valley is an easy three-step
                                        process that we've designed to save time
                                        and ensure a timely response.
                                    </p>
                                </div>
                                <button
                                    class="btn-css"
                                    on:click={() =>
                                        (location.href = '/applyProgram')}
                                >
                                    APPLY NOW
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="back-div" style="position: relative;">
                        <div class="process-div">
                            <h4
                                style="font-size: 1.984vw;
                                font-weight: 600;
                                color: rgb(0, 32, 75);
                                margin-left: 4.63vw;
                                margin-top: 3.638vw;
                                margin-bottom: 2.315vw;"
                            >
                                Process
                            </h4>
                            <ul class="points">
                                {#each Processtext as data}
                                    <li style="">
                                        <p
                                            style="color:rgba(0, 32, 75, 1);
                                        font-size: 1.190vw;font-weight:bold; padding-left:1vw; margin-top:1vw; margin-bottom: 1vw;"
                                        >
                                            {data.heading}
                                        </p>
                                        <p
                                            style="color: rgb(0, 32, 75);
                                            width: 23.487vw;
                                            padding-left: 1vw;
                                            font-size: 1.19vw;
                                            padding-bottom: 1vw;
                                            margin-top: -0.35vw;
                                            line-height: 1.440vw;"
                                        >
                                            {data.text}
                                        </p>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style="display: flex;align-items: center;margin-left: 4vw;margin-top: 4vw;margin-bottom: 3.373vw;"
            >
                <h1
                    class="section1"
                    style="    color: rgb(0, 32, 75);
                    font-size: 1.191vw;
                    margin-right: 5vw;
                    opacity: 0.3;
                    margin-top: 0.6vw;
                "
                >
                    06
                </h1>
                <h1
                    class="section-title"
                    style="font-weight:500;
                color:rgba(0, 32, 75, 1);font-size:2.068vw;"
                >
                    FAQs
                </h1>
            </div>
            <div
                class={user.view_all ? 'view-all' : 'view-less'}
                style="overflow: hidden;"
            >
                <FaqSection detail={FaqHeroTraining} />
            </div>

            {#if !user.view_all}
                <button class="view-all-btn " on:click={toggle}>
                    <p class="view-text ">Load More</p>
                    <div style="width: 0.5vw;margin-left: 0.8vw;">
                        <img
                            src="images/global_section/arrow.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </button>
            {/if}
            {#if user.view_all}
                <button class="view-all-btn  " on:click={toggle}>
                    <p class="view-text ">Load Less</p>
                    <div
                        style="width: 0.5vw;margin-left: 0.8vw;transform: rotate(180deg);"
                    >
                        <img
                            src="images/global_section/arrow.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </button>
            {/if}
        </div>
    </div>
    <div class="mobile">
        <div
            style="display: flex;align-items:center; margin-left:5.556vw;margin-top: 24.766vw; margin-bottom: 5vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
            >
                01
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
            >
                Curriculum Highlights
            </h1>
        </div>
        <CurriculumMbl curriculumMbl={heroCurriculumMbl} />
        <div
            style="display: flex;align-items:center; margin-left:5.556vw;margin-top: -6vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;margin-top: -2vw;"
            >
                02
            </h1>
            <div style="margin-top:16vw;">
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
                >
                    Speakers
                </h1>
                <p
                    style="width:72.778vw; font-size:3.889vw; line-height:6.111vw;text-align: center;"
                >
                    Pitch to the leading investors and build with the brightest
                    minds in the world.
                </p>
            </div>
        </div>
        <div style="margin-top: 5vw;">
            <SpeakerSlider data={speakerSection} />
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.556vw;margin-top: 16vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;margin-top: -8vw;"
            >
                03
            </h1>
            <h1
                class="section-title"
                style="width:47.889vw; color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
            >
                Benefits of the Program
            </h1>
        </div>
        <div style="margin-top: 5vw;">
            {#each benefitsMbl as benefits}
                <div
                    class="benefits-div"
                    style="background-color:{benefits.back_color};"
                >
                    <div class="benefits_img">
                        <img src={benefits.image} alt="" width="100%" />
                    </div>
                    <div style="width:56.667vw;margin-left:5.077vw;">
                        <p
                            class="benefits_heading"
                            style="padding: 2.5vw 0vw 2.715vw;"
                        >
                            {benefits.heading}
                        </p>
                        <p class="benefits_text" style=" margin:auto;">
                            {benefits.paragraph}
                        </p>
                    </div>
                </div>
            {/each}
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 16vw;
        margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
            >
                04
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
            >
                Alumni Success Stories
            </h1>
        </div>
        <SliderRightMbl sliderRight={sliderRightMbl} />
        <SliderLeftMbl sliderLeft={sliderLeftMbl} />
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: -2vw;
        margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;margin-top:8.2vw;"
            >
                05
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;margin-top: 8vw;"
                >
                    DUV Companies
                </h1>
            </div>
        </div>
        <div style="width: 89.722vw;margin: auto;">
            <img
                src="/images/fundamental_programs/Logo_mbl.png"
                alt=""
                width="100%"
            />
        </div>
        <div style="    width: 86.5vw;margin: 7vw 0vw 7vw 11.778vw;">
            <div>
                <h1
                    style="color: rgba(124, 193, 255, 0.2);font-size:16.45vw; font-weight: bold;margin-left: 4vw;"
                >
                    Become a Hero
                </h1>
            </div>
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: -19vw;
        margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3; margin-top: -23vw;"
            >
                06
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;margin-top: 8vw;"
                >
                    Application
                </h1>
                <div style="width:65.556vw; margin:2vw 0vw">
                    <p style="font-size:3.056vw">
                        Applying for entrepreneurship training in Silicon Valley
                        is an easy three-step process that we've designed to
                        save time and ensure a timely response.
                    </p>
                </div>
                <button
                    class="btn-css-mbl"
                    on:click={() => (location.href = '/applyProgram')}
                    >Apply</button
                >
            </div>
        </div>
        <div class="process-div-mbl">
            <h4
                style="font-size:5.556vw; font-weight:600; color:#00204B;padding: 4.5vw 27vw 2.5vw 27vw;"
            >
                Process
            </h4>
            <ul class="process_mbl">
                {#each Processtext as data}
                    <li style="">
                        <p
                            style="font-size: 3.056vw;font-weight:bold; padding-left:1vw; margin-top:4vw;"
                        >
                            {data.heading}
                        </p>
                        <p
                            style="width: 58.778vw;padding-left: 1vw;font-size: 3.056vw;line-height: 3.697vw;margin-top:4vw;"
                        >
                            {data.text}
                        </p>
                    </li>
                {/each}
            </ul>
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 16vw;
        margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
            >
                07
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600;"
            >
                FAQs
            </h1>
        </div>
        <div
            class={userMbl.view_all_mbl ? 'view-all_mbl' : 'view-less_mbl'}
            style="overflow: hidden;"
        >
            <FaqMbl detailMbl={FaqHeroTraining} />
        </div>

        {#if !userMbl.view_all_mbl}
            <button class="view-all-btn_mbl " on:click={toggleMbl}>
                <p class="view-text_mbl ">Load More</p>
                <div style="width: 2vw;margin-left: 1.98vw;margin-top: -1.5vw;">
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}
        {#if userMbl.view_all_mbl}
            <button class="view-all-btn_mbl  " on:click={toggleMbl}>
                <p class="view-text_mbl ">Load Less</p>
                <div
                    style="width: 2vw;margin-left: 1.98vw;;transform: rotate(180deg);margin-top: -1.5vw;"
                >
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}
    </div>
    <div style="margin-top: 5vw;">
        <Footer />
    </div>
</section>

<style>
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .benefits-div {
            width: 78.611vw;
            height: 31.944vw;
            border-radius: 5.556vw;
            box-shadow: 0px -4.444vw 20.556vw rgba(124, 193, 255, 0.2);
            margin: auto;
            margin-top: 4vw;
            display: flex;
        }
        .benefits_img {
            margin-top: 2.5vw;
            width: 6vw;
            margin-left: 5.556vw;
        }
        .benefits_heading {
            font-size: 4.444vw;
            font-weight: 600;
            color: white;
            margin: 0;
            padding: 0;
        }
        .benefits_text {
            font-size: 2.778vw;
            font-weight: 300;
            color: white;
            line-height: 4.166vw;
            margin: 0;
            padding: 0;
        }
    }
    .speaker_box::after {
        content: "";
        height: 1.19vw;
        width: 1.19vw;
        background: #f7e05f;
        position: absolute;
        bottom: -0.8vw;
        z-index: 1;
        border-radius: 5vw;
        left: -0.7vw;
    }
    .speaker_box:nth-child(5)::after {
        left: 0vw;
    }
    .speaker_box {
        width: 16.667vw;
        height: 17.394vw;
        border: 0.198vw solid #7cc1ff;
        border-right: none;
        border-bottom: none;
        position: relative;
    }
    .speaker_box:nth-child(4) {
        border-right: 0.198vw solid #7cc1ff;
    }
    .speaker_box:nth-child(8) {
        border-right: 0.198vw solid #7cc1ff;
        border-bottom: 0.198vw solid #7cc1ff;
        border-bottom-right-radius: 1vw;
    }
    .speaker_box:nth-child(5) {
        border-bottom: 0.198vw solid #7cc1ff;
        border-bottom-left-radius: 1vw;
    }
    .speaker_box:nth-child(1) {
        border-top-left-radius: 1vw;
    }
    .speaker_box:nth-child(4) {
        border-top-right-radius: 1vw;
    }
    .speaker_box:nth-child(6) {
        border-bottom: 0.198vw solid #7cc1ff;
    }
    .speaker_box:nth-child(7) {
        border-bottom: 0.198vw solid #7cc1ff;
    }
    /* .text {
        overflow: hidden;
        height: 100%;
        border-bottom-left-radius: 0.7vw;
        border-bottom-right-radius: 0.7vw;
    } */
    section {
        font-family: "inter";
    }
    .circle {
        height: 24.802vw;
        width: 24.802vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        top: -4vw;
        left: -21vw;
        background-color: rgba(60, 136, 195, 0.33);
        justify-content: center;
    }
    .circle:nth-child(2) {
        top: 6.5vw;
    }
    .circle:nth-child(3) {
        top: 17.5vw;
    }
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 1vw;
        border-top-right-radius: 1vw;
    }
    .speaker {
        display: flex;
        position: relative;
    }
    .inner-circle {
        width: 11.706vw;
        height: 11.706vw;
        top: 16.931vw;
        left: 28.968vw;
        background-color: #7cc1ff;
        border-radius: 50%;
        position: absolute;
    }
    .funnel-div {
        width: 24.537vw;
        background: #36a1bf;
        border-radius: 1.323vw;
        top: 4.762vw;
        height: 14.087vw;
        left: 12.302vw;
        padding-top: 2.712vw;
        position: absolute;
    }
    .fund-icon {
        width: 2vw;
    }
    .fund-heading {
        font-size: 1.455vw;
        font-weight: 600;
        text-align: center;
        color: white;
    }
    .fund-text {
        font-size: 1.19vw;
        font-weight: 300;
        text-align: center;
        color: white;
    }
    .expert-div {
        width: 24.537vw;
        height: 15.1vw;
        background: #3c74c0;
        border-radius: 1.323vw;
        top: 11.905vw;
        left: 34.788vw;
        padding-top: 2vw;
        position: absolute;
    }
    .globel-div {
        background: #16519a;
        width: 24.537vw;
        border-radius: 1.323vw;
        padding-top: 1.7vw;
        top: 19.841vw;
        height: 15.881vw;
        left: 9.325vw;
        position: absolute;
    }
    .growth-div {
        background: #15248e;
        width: 24.537vw;
        height: 15.087vw;
        border-radius: 1.323vw;
        top: 28vw;
        left: 32.077vw;
        padding-top: 2.3vw;
        position: absolute;
    }
    .btn-css {
        background-color: #3c74c0;
        border-radius: 1.984vw;
        color: white;
        font-weight: 500;
        border: none;
        width: 9.656vw;
        height: 3.2vw;
        font-size: 0.926vw;
    }
    .btn-css:hover {
        background-color: #f7e05f;
        border: 0.194vw solid #f7e05f;
        color: #3c74c0;
        width: 9.656vw;
        height: 3.2vw;
        font-weight: 500;
        font-size: 0.926vw;
    }
    .btn-css-mbl {
        background-color: #3c74c0;
        border-radius: 8.333vw;
        color: white;
        font-weight: 500;
        border: none;
        width: 31.666vw;
        height: 8.334vw;
        font-size: 3.056vw;
    }
    .back-div {
        width: 37.963vw;
        height: 50vw;
        background: linear-gradient(155.25deg, #9ec7ff 1.68%, #064cab 84.22%);
        border-radius: 3vw 3vw 1.5vw 1.5vw;
    }
    .process-div {
        position: absolute;
        width: 33.466vw;
        height: 45.5vw;
        background-color: white;
        top: 4.696vw;
        left: 2.249vw;
        border-radius: 3vw 3vw 0vw 0vw;
    }
    .process-div-mbl {
        width: 76.111vw;
        height: 122vw;
        background-color: white;
        border-radius: 7vw 7vw 0vw 0vw;
        box-shadow: 0px -9px 20px rgba(60, 116, 192, 0.2);
        margin: auto;
        margin-top: 10vw;
    }
    .points {
        margin-left: 5.5vw;
    }
    .process_mbl li::marker {
        color: #7cc1ff;
        font-size: 4.19vw;
    }
    ul {
        padding: 0;
        margin: 0;
        margin-left: 9.556vw;
        line-height: 1.2vw;
    }
    ul li::marker {
        color: #7cc1ff;
        font-size: 1.19vw;
    }
    .view-all-btn {
        display: flex;
        border: none;
        background-color: transparent;
        margin: auto;
        margin-top: 2vw;
    }
    /* .view-all {
        height: 180vw;
    } */
    .view-less {
        height: 66.5vw;
        margin-bottom: 4.299vw;
    }
    .view-text {
        color: #00204b;
        font-size: 0.921vw;
        font-weight: 600;
        margin-bottom: 0;
    }
    .view-all-btn_mbl {
        display: flex;
        border: none;
        background-color: transparent;
        margin: auto;
        margin-top: 2vw;
    }

    .view-text_mbl {
        color: #00204b;
        font-size: 3.056vw;
        font-weight: 600;
        margin-bottom: 0;
    }
    .view-all_mbl {
        height: 565vw;
    }
    .view-less_mbl {
        height: 95vw;
    }
</style>
